import { useContext } from "react";
import { API } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";

import CropTypeForm from "components/agro/cropTypes/CropTypeForm";
import { createCropType } from "graphql/mutations";
import { LayoutContext } from "layout/context/LayoutContext";

const CropTypeCreateForm = ({ onSuccess }) => {
  const { me } = useContext(LayoutContext);
  const cropType = {
    name: "",
    companyID: me?.companyID ?? "",
    cropUnitID: "",
  };

  async function onSubmit(valuesParam) {
    try {
      const {
        name,
        companyID,
        cropUnitID,
      } = valuesParam;

      await API.graphql({
        query: createCropType.replaceAll("__typename", ""),
        variables: {
          input: {
            name,
            companyID,
            cropUnitID,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
    } catch (err) {
      toast.error(strings.responses.errorCreate);
      console.error(err);
    }
  }

  return (
    <div>
      <CropTypeForm onSubmit={onSubmit} initialValues={cropType} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    successAdded: "Tipo de Cultivo agregado con éxito",
    responses: {
      errorCreate: "Error al crear tipo de cultivo",
    },
  },
});

export default CropTypeCreateForm;
